import React, { useState } from 'react';
import dayjs from 'dayjs';

import { downloadFile } from 'utility/downloadFile';
import urls from 'engine/urls';

import { Box, Button } from 'components/ui';
import { DateRange } from 'components/containers';

import * as Styled from './EdiExport.styles';

export const EdiExport = ({onErrorResponse}) => {
  const [filters, setFilters] = useState({
    fromDate: dayjs().utc(true).subtract(30, 'day').format('YYYY-MM-DD'),
    toDate: dayjs().utc(true).format('YYYY-MM-DD'),
  });

  const handleExport = () => {
    const params = {
      from: dayjs.utc(filters.fromDate).toISOString(),
      to: dayjs.utc(filters.toDate).endOf('day').toISOString(),
    };

    downloadFile(
      `${urls().GetExportEdi}?from=${params.from}&to=${params.to}`,
      'application/octet-stream',
      'export.epp',
      onErrorResponse
    );
  };

  return (
    <Styled.Wrapper>
      <Box
        title="Eksport EDI"
        helperTitle="EDI"
        helperMessage="Wygenerowany plik EDI może zostać wykorzystany do importu dokumentów do systemów rodziny Insert."
      >
        <Styled.DateRangeWrapper>
          <DateRange
            onChange={(dates) => setFilters({ ...filters, ...dates })}
            toDate={filters.toDate}
            fromDate={filters.fromDate}
          />
        </Styled.DateRangeWrapper>

        <Button onClick={handleExport}>Eksportuj</Button>
      </Box> 
    </Styled.Wrapper>
  );
};
